import React from 'react';

interface CheckProps {
  className?: string;
  size?: number;
  fill?: string;
  strokeWidth?: number;
}

const Check: React.FC<CheckProps> = ({ className, size, fill, strokeWidth }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size || '32'}
    height={size || '32'}
    fill={fill || 'currentColor'}
    viewBox="0 0 256 256"
    strokeWidth={strokeWidth || 1}
    className={className}
  >
    <path
      strokeWidth={strokeWidth || 1}
      d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"
    />
  </svg>
);

export default Check;
